import ApiService from "@/store/api-service";
import { BASE_URL } from "../../../config";

// Above the server's worst case (up to 4 sequential 14s upstream calls), so a
// create/cancel is not reported as failed while it is still completing
const REQUEST_TIMEOUT_MS = 60000;

// Calls the Moj agency APIs through tools-api-service with the logged-in user's token.
// The agency is resolved server side from the user's account, so it is never sent from here.
export async function callMojAgency(accessToken, func, params = {}) {
	const endpoint = `${BASE_URL}/moj-agency/v1.0.0/${func}`;
	let data;
	try {
		data = await ApiService.post(
			endpoint,
			{ access_token: accessToken, params },
			{ timeout: REQUEST_TIMEOUT_MS },
			true
		);
	} catch (err) {
		// Non-2xx replies (e.g. 401 for a bad token) carry the reason in errMsg
		const serverMsg = getErrMsg(err && err.response && err.response.data);
		if (serverMsg) {
			throw new Error(serverMsg);
		}
		throw err;
	}
	if (data && data.statusCode === 200) {
		return data.response;
	}
	throw new Error(getErrMsg(data) || "Something went wrong");
}

function getErrMsg(data) {
	const errMsg = data && data.errMsg;
	return (errMsg && (errMsg.message || errMsg)) || null;
}
